import { Col, Row } from "react-bootstrap";
import SignInInput from "../../../common/SigninInput/signinInput";
import styles from "../onboard.module.css";
import Dropdown from "../../Dropdown/dropdown";
import DateInputWithCalendar from "../../../common/DateCalender/DateCalender";
import CommonButton from "../../CommonButton/CommonButton";

function RemitterForm({
  placeOfIssue,
  placeOfIssueError,
  selectedDocument,
  setSelectedDocument,
  name,
  handleChange,
  handleBlur,
  valid,
  email,
  emailError,
  phoneNumber,
  phoneNoError,
  panNumber,
  panError,
  // handleChangeOption,
  postalCode,
  postalError,
  address,
  city,
  state,
  dob,
  onHandleDate,
  dobError,
  nextSectionError,
  checkIfValid,
  loading,
  themeColor,
  aadhaarNo,
  aadhaarError,
  nameOnPassport,
  nameOnPassportError,
  passportNo,
  passportNoError,
  passportIssueDate,
  passportIssueDateError,
  passportExpiryDate,
  passportExpiryDateError,
  selectedDocumentError,
}) {
  // const RelationOption = [
  //   {
  //     label: "Parent",
  //     value: "Parent",
  //   },
  //   {
  //     label: "Sibling",
  //     value: "Sibling",
  //   },
  //   {
  //     label: "Spouse",
  //     value: "Spouse",
  //   },
  //   {
  //     label: "Self",
  //     value: "Self",
  //   },
  // ];

  const documentTypeOptions = [
    {
      label: "Aadhaar",
      value: "Aadhaar",
    },
    {
      label: "Passport",
      value: "Passport",
    },
  ];

  const handleDocumentChange = (selectedOption) => {
    setSelectedDocument(selectedOption);
  };

  return (
    <>
      <Row>
        <Col md={4}>
          <SignInInput
            name="name"
            label="Full Name"
            placeholder="Enter Full Name"
            type="text"
            value={name}
            containerClasses={styles.passwordInvalid}
            onChange={(event) => {
              handleChange(event);
            }}
            isInvalid={valid.name}
          />
        </Col>
        <Col md={4}>
          <SignInInput
            name="email"
            label="Email ID"
            placeholder="Enter Email ID"
            type="text"
            value={email}
            containerClasses={styles.passwordInvalid}
            onChange={(event) => {
              handleChange(event);
            }}
            errorMessage={emailError}
            isInvalid={valid.email}
            onBlur={(event) => {
              handleBlur(event);
            }}
          />
        </Col>
        <Col md={4}>
          <SignInInput
            name="phoneNumber"
            label="Phone Number"
            placeholder="Enter Phone Number"
            type="number"
            value={phoneNumber}
            containerClasses={styles.passwordInvalid}
            onChange={(event) => {
              handleChange(event);
            }}
            isInvalid={valid.phoneNumber}
            onBlur={(event) => {
              handleBlur(event);
            }}
            errorMessage={phoneNoError}
            showcodediv={true}
            codedivName={"phone"}
          />
        </Col>
      </Row>
      <Row className="pt-2">
        <Col md={4}>
          <SignInInput
            name="PAN"
            label="PAN Number"
            placeholder="Enter PAN number"
            type="text"
            value={panNumber}
            containerClasses={styles.passwordInvalid}
            onChange={(event) => {
              handleChange(event);
            }}
            onPaste={(e) => {
              e.preventDefault();
              return false;
            }}
            onCopy={(e) => {
              e.preventDefault();
              return false;
            }}
            isInvalid={valid.panNumber}
            onBlur={(event) => {
              handleBlur(event);
            }}
            errorMessage={panError}
          />
        </Col>
        {/* <Col md={4}>
          <Dropdown
            options={RelationOption}
            label="Select"
            heading="Relation with Student"
            onChange={handleChangeOption}
          />
        </Col> */}
        <Col md={4}>
          <SignInInput
            name="Postal"
            label="Postal Code"
            placeholder="Enter Postal Code"
            type="number"
            value={postalCode}
            containerClasses={styles.passwordInvalid}
            onChange={(event) => {
              handleChange(event);
            }}
            onBlur={(event) => {
              handleBlur(event);
            }}
            isInvalid={valid.postalCode}
            errorMessage={postalError}
          />
        </Col>
        <Col md={4}>
          <SignInInput
            name="Country"
            label="Country"
            placeholder="Enter Country"
            type="text"
            value={"India"}
            disabled={true}
            isInvalid={valid.country}
          />
        </Col>
      </Row>
      <Row className="pt-2">
        <Col md={4}>
          <SignInInput
            name="Address"
            label="Address"
            placeholder="Enter Full Address"
            type="text"
            value={address}
            containerClasses={styles.passwordInvalid}
            onChange={(event) => {
              handleChange(event);
            }}
            isInvalid={valid.address}
          />
        </Col>
        <Col md={4}>
          <SignInInput
            name="City"
            label="City"
            placeholder="Enter City"
            type="text"
            value={city}
            containerClasses={styles.passwordInvalid}
            onChange={(event) => {
              handleChange(event);
            }}
            isInvalid={valid.city}
          />
        </Col>
        <Col md={4}>
          <SignInInput
            name="State"
            label="State"
            placeholder="Enter State"
            type="text"
            value={state}
            containerClasses={styles.passwordInvalid}
            onChange={(event) => {
              handleChange(event);
            }}
            isInvalid={valid.state}
          />
        </Col>
      </Row>
      <Row className="pt-2">
        <DateInputWithCalendar
          label="DOB"
          placeholder="Enter DOB"
          name="dateofbirth"
          value={dob}
          onHandleDate={(date) => onHandleDate(date, "dateofbirth")}
          errorMessage={dobError}
        />
        <Col md={4}>
          <Dropdown
            options={documentTypeOptions}
            label="Select"
            heading="Select Document Type"
            onChange={handleDocumentChange}
            errorMessage={selectedDocumentError}
          />
        </Col>

        {selectedDocument === "Aadhaar" && (
          <Col md={4}>
            <SignInInput
              name="aadhaarNo"
              label="Aadhaar Number"
              placeholder="Enter Aadhaar Number"
              type="text"
              value={aadhaarNo}
              containerClasses={styles.passwordInvalid}
              onChange={handleChange}
              onBlur={handleBlur}
              isInvalid={valid.aadhaarNo}
              errorMessage={aadhaarError}
            />
          </Col>
        )}

        {selectedDocument === "Passport" && (
          <Col md={4}>
            <SignInInput
              name="nameOnPassport"
              label="Name on Passport"
              placeholder="Enter Name on Passport"
              type="text"
              value={nameOnPassport}
              containerClasses={styles.passwordInvalid}
              onChange={handleChange}
              onBlur={handleBlur}
              isInvalid={valid.nameOnPassport}
              errorMessage={nameOnPassportError}
            />
          </Col>
        )}
      </Row>

      {selectedDocument === "Passport" && (
        <>
          <Row className="pt-2">
            <Col md={4}>
              <SignInInput
                name="passportNo"
                label="Passport Number"
                placeholder="Enter Passport Number"
                type="text"
                value={passportNo}
                containerClasses={styles.passwordInvalid}
                onChange={handleChange}
                onBlur={handleBlur}
                isInvalid={valid.passportNo}
                errorMessage={passportNoError}
              />
            </Col>

            <Col md={4}>
              <SignInInput
                name="placeOfIssue"
                label="Place of Issue"
                placeholder="Enter Place of Issue"
                type="text"
                value={placeOfIssue}
                containerClasses={styles.passwordInvalid}
                onChange={handleChange}
                onBlur={handleBlur}
                isInvalid={valid.placeOfIssue}
                errorMessage={placeOfIssueError}
              />
            </Col>

            <DateInputWithCalendar
              label="Date of Passport Issue"
              placeholder="Date of Passport Issue"
              name="passportIssueDate"
              value={passportIssueDate}
              onHandleDate={(date) => onHandleDate(date, "passportIssueDate")}
              disabled={dob === ""}
              mindate={dob}
              errorMessage={passportIssueDateError}
            />
          </Row>

          <Row className="pt-2">
            <DateInputWithCalendar
              label="Date of Passport Expiry"
              placeholder="Date of Passport Expiry"
              name="passportExpiryDate"
              value={passportExpiryDate}
              onHandleDate={(date) => onHandleDate(date, "passportExpiryDate")}
              disabled={dob === "" || passportIssueDate === ""}
              errorMessage={passportExpiryDateError}
            />
          </Row>
        </>
      )}

      <Row className="pt-3 mt-3">
        <div className={styles.errorState}>{nextSectionError}</div>
        {/* <Col md={3}> */}
        <CommonButton
          title="Next"
          onClick={checkIfValid}
          loading={loading}
          disabled={loading}
          width={"150px"}
        />
      </Row>
    </>
  );
}

export default RemitterForm;
